/* Generated from Module-Equivalences-DTC.html. */
window.NuoroModules=window.NuoroModules||{};
window.NuoroModules["equivalences"]=function(root){
const document=window.NuoroModuleDocument(root);
/* Original storefront sections, with standalone vanilla interactions. */
(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.nutrients-slider__item').forEach(card => {
    const front = card.querySelector('.nutrients-slider__item-front');
    const back = card.querySelector('.nutrients-slider__item-back');
    const open = card.querySelector('.js-flip-btn');
    const close = card.querySelector('.js-flip-back-btn');
    if (!open || !close) return;
    const flip = value => {
      card.classList.toggle('is-flipped', value);
      open.setAttribute('aria-expanded', String(value));
      front.inert = value;
      back.inert = !value;
      back.setAttribute('aria-hidden', String(!value));
    };
    flip(false);
    close.setAttribute('aria-label', 'Revenir à la famille d’ingrédients');
    open.addEventListener('click', () => { flip(true); close.focus({preventScroll:true}); });
    close.addEventListener('click', () => { flip(false); open.focus({preventScroll:true}); });
    card.addEventListener('keydown', event => {
      if (event.key === 'Escape') { flip(false); open.focus({preventScroll:true}); }
    });
  });

  document.querySelectorAll('.swiper').forEach(view => {
    const loop = view.classList.contains('infinity-slider-v2__content');
    const track = view.querySelector('.swiper-wrapper');
    if (loop) {
      [...track.children].forEach(item => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        track.appendChild(clone);
      });
    }
    let dragging = false, startX = 0, startScroll = 0, moved = false;
    let hovered = false, visible = false, last = 0, resumeAt = 0;
    const cycleWidth = () => loop ? track.children[6].offsetLeft - track.children[0].offsetLeft : 0;
    const normalize = () => {
      if (!loop) return;
      const width = cycleWidth();
      if (width && view.scrollLeft >= width) view.scrollLeft -= width;
    };
    view.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return;
      dragging = true; moved = false; startX = event.clientX; startScroll = view.scrollLeft;
      view.setPointerCapture(event.pointerId);
      view.classList.add('is-dragging');
    });
    view.addEventListener('pointermove', event => {
      if (!dragging) return;
      moved ||= Math.abs(event.clientX - startX) > 5;
      view.scrollLeft = startScroll - (event.clientX - startX);
    });
    const release = () => { dragging = false; view.classList.remove('is-dragging'); resumeAt = performance.now() + 1800; };
    view.addEventListener('pointerup', release);
    view.addEventListener('pointercancel', release);
    view.addEventListener('click', event => { if (moved) { event.preventDefault(); moved = false; } }, true);
    view.addEventListener('mouseenter', () => { hovered = true; });
    view.addEventListener('mouseleave', () => { hovered = false; });
    view.addEventListener('wheel', () => { resumeAt = performance.now() + 1800; }, {passive:true});
    view.addEventListener('touchstart', () => { dragging = true; }, {passive:true});
    view.addEventListener('touchend', release, {passive:true});
    view.addEventListener('keydown', event => {
      if (event.target !== view || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); resumeAt = performance.now() + 3000;
      view.scrollBy({left:(event.key === 'ArrowRight' ? 1 : -1) * 364,behavior:reducedMotion.matches ? 'instant' : 'smooth'});
    });
    if (!loop) {
      const section = view.closest('.nutrients-slider__wrapper');
      const previous = section.querySelector('[data-nutrients-prev]');
      const next = section.querySelector('[data-nutrients-next]');
      const updateArrows = () => {
        if (!previous || !next) return;
        previous.disabled = view.scrollLeft <= 2;
        next.disabled = view.scrollLeft >= view.scrollWidth - view.clientWidth - 2;
      };
      const advance = direction => {
        const cards = track.children;
        const distance = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : view.clientWidth;
        view.scrollBy({left:direction * distance,behavior:reducedMotion.matches ? 'instant' : 'smooth'});
      };
      previous?.addEventListener('click', () => advance(-1));
      next?.addEventListener('click', () => advance(1));
      view.addEventListener('scroll', updateArrows, {passive:true});
      new ResizeObserver(updateArrows).observe(view);
      document.fonts.ready.then(updateArrows);
      updateArrows();
      return;
    }
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }).observe(view);
    const animate = time => {
      const delta = last ? Math.min(time - last, 50) : 0;
      last = time;
      if (visible && !document.hidden && !dragging && !hovered && !view.matches(':focus-within') && !reducedMotion.matches && time > resumeAt) {
        view.scrollLeft += delta * .09;
        normalize();
      }
      requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  });
})();

(function(){
 const d=document, mobile=matchMedia('(max-width:1023px)').matches, module=d.body.dataset.nuoroModule;
 // Mobile navigation is added around the existing desktop links, without a second header source.
 const desktopNav=d.querySelector('.hero>.nav');
 if(mobile&&desktopNav&&!desktopNav.querySelector('.nuoro-mobile-toggle')){
  const toggle=d.createElement('button');toggle.className='nuoro-mobile-toggle';toggle.type='button';toggle.setAttribute('aria-label','Ouvrir le menu');toggle.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h16"/></svg>';
  desktopNav.prepend(toggle);toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-haspopup','dialog');toggle.onclick=()=>window.NuoroNavigation.openMenu(root);
 }
 if(module==='Fondateurs')d.querySelectorAll('a.cta').forEach(a=>{a.href='/pages/mission';a.addEventListener('click',e=>{e.preventDefault();window.location.href=a.href})});
 if(module==='Avis')d.querySelectorAll('.lnk').forEach(a=>{a.href='https://fr.trustpilot.com/review/drinknuoro.com';a.target='_blank';a.rel='noopener'});
 const requestShop=()=>window.NuoroNavigation.goShop();
 d.querySelectorAll('a[href="#"],a[href="#shop"],a[href="#featured--product"]').forEach(a=>{
  if(/cta|btn/.test(a.className)||/essayer|commencer|découvrir|choisir|économisez|economisez/i.test(a.textContent))a.addEventListener('click',e=>{e.preventDefault();requestShop()});
  else if(/gérer mon abonnement/i.test(a.textContent)){a.href='https://drinknuoro.com/a/account/login';a.target='_top'}
  else if(/service client/i.test(a.textContent))a.href='/pages/assistance';
 });
 d.querySelectorAll('[aria-label="Mon compte"]').forEach(b=>b.addEventListener('click',()=>{window.location.href='https://drinknuoro.com/a/account/login'}));
 const burger=d.querySelector('.nuoro-mobile-toggle,.nav-burger'), nav=d.querySelector('.nav'), menu=d.querySelector('.nuoro-mobile-menu,.nav-menu');
 if(burger&&nav&&menu){
  menu.id='mobile-navigation';burger.setAttribute('aria-controls',menu.id);
  const sync=()=>{const open=nav.classList.contains('open');burger.setAttribute('aria-expanded',String(open));burger.setAttribute('aria-label',open?'Fermer le menu':'Ouvrir le menu');};sync();new MutationObserver(sync).observe(nav,{attributes:true,attributeFilter:['class']});
  const start=d.createElement('a');start.href='#shop';start.textContent='Choisir ma formule';start.addEventListener('click',e=>{e.preventDefault();nav.classList.remove('open');requestShop()});menu.append(start);
  d.addEventListener('keydown',e=>{if(e.key==='Escape'){nav.classList.remove('open');burger.focus();parent.postMessage({nuoroCloseCart:true},location.origin)}});
 }
 if(module==='Shop'){
  const sync=()=>d.querySelectorAll('.flavor,.qty-opt,.freq').forEach(b=>b.setAttribute('aria-pressed',String(b.classList.contains('active'))));sync();
  ['flavors','qty','freqs'].forEach(id=>{const el=d.getElementById(id);if(el)new MutationObserver(sync).observe(el,{subtree:true,attributes:true,attributeFilter:['class']})});
  d.querySelectorAll('.acc-head').forEach((b,i)=>{const answer=b.parentElement.querySelector('.acc-body');if(answer){answer.id='shop-answer-'+i;b.setAttribute('aria-controls',answer.id);const syncAcc=()=>{b.setAttribute('aria-expanded',String(b.parentElement.classList.contains('open')))};syncAcc();new MutationObserver(syncAcc).observe(b.parentElement,{attributes:true,attributeFilter:['class']})}});
 }
 if(mobile)d.querySelectorAll('.clin-t br,.freefrom__headline .claim br').forEach(br=>br.replaceWith(d.createTextNode(' ')));
 if(module==='Hero'){
  const cta=d.querySelector('a.cta');
  if(cta){const label=[...cta.childNodes].find(n=>n.nodeType===3&&/19%/.test(n.textContent));if(label){const original=label.textContent,phone=matchMedia('(max-width:767px)');const syncLabel=()=>{label.textContent=phone.matches?'−19% + cadeaux offerts ':original};syncLabel();phone.addEventListener('change',syncLabel)}}
 }
 if(mobile&&module==='Hero'){
  const fibreLabel=d.querySelector('.stat:nth-child(3) .lab');if(fibreLabel)fibreLabel.innerHTML='grammes<br>de fibres';

  const refund=d.querySelector('.reassure .item:not(.hero-delivery)');if(refund)refund.textContent='Satisfait ou remboursé 5 sticks';
  const delivery=d.querySelector('.hero-delivery');if(delivery)delivery.textContent='Livraison 48h';
  const qualities=d.querySelector('.hero-qualities');
  if(qualities){const items=qualities.textContent.split(' - ');qualities.replaceChildren(...items.map(text=>{const span=d.createElement('span');span.className='hero-quality';span.textContent=text.trim();return span}))}
 }
 if(mobile&&module==='Shop'){
  const support=d.querySelector('.shop__support p');if(support){const strong=d.createElement('strong');strong.textContent='Service client 7j/7';support.replaceChildren(strong)}
  const refund=d.querySelector('.post-cta .shop__refund strong');if(refund)refund.textContent='Satisfait ou remboursé 5 sticks';
  const terms=d.querySelector('.freq.best .fsub');
  if(terms){const delivery=terms.querySelector('[data-fsub-boxes]');if(delivery){const condition=d.createElement('span');condition.className='subscription-condition';condition.textContent=[...terms.childNodes].filter(n=>n!==delivery).map(n=>n.textContent).join('').replace(/^\s*·\s*/, '');terms.replaceChildren(delivery,d.createTextNode(" "),condition)}}
  const rail=d.querySelector('.prepare .steps');
  if(rail){
   const cards=[...rail.children], controls=d.createElement('div'), dots=d.createElement('div'), hint=d.createElement('p');
   rail.id='preparation-steps';rail.tabIndex=0;rail.setAttribute('role','region');rail.setAttribute('aria-label','Les trois étapes de préparation, faites glisser');
   controls.className='prepare-controls';dots.className='prepare-dots';dots.setAttribute('role','group');dots.setAttribute('aria-label','Choisir une étape');hint.className='prepare-hint';hint.textContent='Faites glisser pour découvrir';
   let current=0,queued=false;
   const select=i=>{current=i;[...dots.children].forEach((button,j)=>{if(i===j)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current')})};
   const go=i=>{i=Math.max(0,Math.min(cards.length-1,i));rail.scrollTo({left:cards[i].offsetLeft-cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};
   cards.forEach((card,i)=>{
    card.setAttribute('role','group');card.setAttribute('aria-label','Étape '+(i+1)+' sur '+cards.length);
    const label=d.createElement('span');label.className='step-label';label.textContent='ÉTAPE '+(i+1);card.querySelector('p').before(label);
    const button=d.createElement('button');button.type='button';button.setAttribute('aria-label','Voir l’étape '+(i+1));button.setAttribute('aria-controls',rail.id);button.onclick=()=>go(i);dots.append(button);
   });
   select(0);controls.append(hint,dots);rail.after(controls);
   const syncStep=()=>{queued=false;const left=rail.getBoundingClientRect().left;let nearest=0,distance=Infinity;cards.forEach((card,i)=>{const delta=Math.abs(card.getBoundingClientRect().left-left);if(delta<distance){distance=delta;nearest=i}});if(rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-2)nearest=cards.length-1;select(nearest)};
   rail.addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(syncStep)}},{passive:true});
   rail.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current+(e.key==='ArrowRight'?1:-1))}else if(e.key==='Home'||e.key==='End'){e.preventDefault();go(e.key==='Home'?0:cards.length-1)}});
   new ResizeObserver(syncStep).observe(rail);
  }
 }
 if(mobile&&module==='Avis'){
  const rail=d.querySelector('.wall');if(rail){rail.tabIndex=0;rail.setAttribute('aria-label','Avis clients, défilement horizontal');
   const nav=d.createElement('div');nav.className='mobile-carousel-actions';nav.innerHTML='<button type="button" aria-label="Avis précédent">←</button><button type="button" aria-label="Avis suivant">→</button>';
   nav.children[0].onclick=()=>rail.scrollBy({left:-rail.clientWidth,behavior:'smooth'});nav.children[1].onclick=()=>rail.scrollBy({left:rail.clientWidth,behavior:'smooth'});rail.after(nav);
  }
 }
 if(module==='Comparateur'){
  const rail=d.querySelector('.comparison__scroll'),table=rail?.querySelector('table');
  if(table){
   const picker=d.createElement('label');picker.className='comparison-picker';
   const label=d.createElement('span');label.textContent='Comparer NUORO avec';
   const select=d.createElement('select');select.setAttribute('aria-label','Alternative à comparer avec NUORO');
   const products=[...table.querySelectorAll('thead th')];
   products.slice(2).forEach((cell,i)=>{const option=d.createElement('option');option.value=String(i+2);option.textContent=cell.querySelector('.comparison__name').textContent.trim();select.append(option)});
   picker.append(label,select);rail.before(picker);
   const choose=()=>{const selected=Number(select.value);[...table.querySelectorAll('tr')].forEach(row=>[...row.children].forEach((cell,i)=>cell.classList.toggle('comparison-alt-hidden',i>1&&i!==selected)));[...table.querySelectorAll('col')].forEach((col,i)=>col.classList.toggle('comparison-alt-hidden',i>1&&i!==selected));window.__nuoroFit?.()};
   select.addEventListener('change',choose);choose();
   const phone=matchMedia('(max-width:767px)');
   const sync=()=>{rail.tabIndex=phone.matches?-1:0;rail.setAttribute('aria-label',phone.matches?'Comparaison de NUORO avec l’alternative sélectionnée':'Tableau comparatif, défilement horizontal sur petit écran')};phone.addEventListener('change',sync);sync();
  }
 }
 d.querySelectorAll('img').forEach(img=>{img.decoding='async';if(module==='Hero')img.fetchPriority=img.closest('.dtc-pic')?'high':'auto';else if(!img.closest('.gal-main'))img.loading='lazy'});
 if(mobile&&module==='FAQ'){d.querySelectorAll('.acc-item.open').forEach(item=>{item.classList.remove('open');item.querySelector('.acc-head')?.setAttribute('aria-expanded','false')})}
 d.fonts.ready.then(()=>window.__nuoroFit?.());
})();

document.fonts.ready.then(()=>root.querySelectorAll("h1,h2,h3,h1 *,h2 *,h3 *").forEach(el=>{const c=getComputedStyle(el).color.match(/[\d.]+/g);if(c&&+c[0]>=200&&+c[1]>=80&&+c[1]<=210&&+c[2]<=160&&+c[0]>+c[1]*1.1)el.classList.add("nuoro-title-accent");}));
};
window.NuoroBoot("equivalences");
